import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

const links = [
  { label: "Features", href: "#features", testid: "nav-link-features" },
  { label: "AI Tools", href: "#ai-tools", testid: "nav-link-ai-tools" },
  { label: "Doc Drafter", href: "#doc-drafter", testid: "nav-link-doc-drafter" },
  { label: "HR Suite", href: "#hr-suite", testid: "nav-link-hr-suite" },
  { label: "CRM Demo", href: "#crm-demo", testid: "nav-link-crm-demo" },
];

export default function Navbar() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-200/80 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="navbar-brand-logo" className="flex items-center gap-2.5 group">
          <img src="/logo.png" alt="Opera360 AI logo" className="w-9 h-9 transition-transform duration-500 group-hover:rotate-[360deg]" />
          <span className="font-display font-black text-lg tracking-tight">
            Opera360<span className="text-[#FF5722]"> HR</span>
          </span>
        </a>
        <div className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.testid}
              data-testid={l.testid}
              href={l.href}
              className="text-sm font-semibold text-slate-600 hover:text-[#FF5722] transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            data-testid="nav-link-opera360"
            href="https://www.opera360trains.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-[#2563EB] hover:text-[#FF5722] transition-colors duration-200"
          >
            opera360trains.com ↗
          </a>
        </div>
        <a
          data-testid="nav-cta-button"
          href="#ai-tools"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-[#0F172A] text-white text-sm font-bold hover:bg-[#FF5722] transition-colors duration-300"
        >
          <Sparkles className="w-4 h-4" /> Try AI Free
        </a>
      </nav>
    </motion.header>
  );
}
